"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appReducer = appReducer;

var ActionTypes = _interopRequireWildcard(require("../action-types/index"));

var _pounderUtilities = require("../../pounder-utilities");

var _pounderStores = require("../../pounder-stores");

var _pounderFirebase = require("../../pounder-firebase");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function appReducer(state, action) {
  switch (action.type) {
    case ActionTypes.SET_FOCUSED_TASKLIST_ID:
      return _objectSpread({}, state, {
        focusedTaskListId: action.id,
        isTaskListJumpMenuOpen: false,
        selectedTask: processSelectedTask(state.selectedTask, action.id),
        openTaskOptionsId: -1,
        enableStates: _objectSpread({}, state.enableStates, {
          newTaskFab: action.id !== -1
        })
      });

    case ActionTypes.SELECT_TASK:
      return _objectSpread({}, state, {
        selectedTask: {
          taskListWidgetId: action.taskListWidgetId,
          taskId: action.taskId,
          isInputOpen: false
        },
        focusedTaskListId: action.taskListWidgetId,
        isATaskMoving: false,
        movingTaskId: -1,
        sourceTaskListId: -1,
        openTaskListSettingsMenuId: -1,
        isTaskListJumpMenuOpen: false
      });

    case ActionTypes.OPEN_TASK:
      return _objectSpread({}, state, {
        selectedTask: {
          taskListWidgetId: action.taskListWidgetId,
          taskId: action.taskId,
          isInputOpen: true
        },
        openTaskOptionsId: -1,
        isATaskMoving: false,
        movingTaskId: -1,
        sourceTaskListId: -1,
        openTaskListSettingsMenuId: -1
      });

    case ActionTypes.SET_OPEN_TASK_LIST_WIDGET_HEADER_ID:
      return _objectSpread({}, state, {
        openTaskListWidgetHeaderId: action.value
      });

    case ActionTypes.CLOSE_TASK:
      return _objectSpread({}, state, {
        selectedTask: {
          taskListWidgetId: action.taskListWidgetId,
          taskId: action.taskId,
          isInputOpen: false
        }
      });

    case ActionTypes.SET_IS_APP_DRAWER_OPEN:
      return _objectSpread({}, state, {
        isAppDrawerOpen: action.value
      });

    case ActionTypes.START_TASK_MOVE:
      return _objectSpread({}, state, {
        isATaskMoving: true,
        selectedTask: {
          taskListWidgetId: action.sourceTaskListWidgetId,
          taskId: action.taskId,
          isInputOpen: false
        },
        focusedTaskListId: action.sourceTaskListWidgetId,
        movingTaskId: action.movingTaskId,
        sourceTaskListId: action.sourceTaskListWidgetId,
        openTaskListSettingsMenuId: -1
      });

    case ActionTypes.START_TASK_MOVE_IN_DATABASE:
      return _objectSpread({}, state, {
        isAwaitingFirebase: true
      });

    case ActionTypes.END_TASK_MOVE:
      return _objectSpread({}, state, {
        isAwaitingFirebase: false,
        isATaskMoving: false,
        sourceTaskListId: -1,
        movingTaskId: -1,
        selectedTask: {
          taskListWidgetId: action.destinationTaskListWidgetId,
          taskId: action.movedTaskId,
          isInputOpen: false
        }
      });

    case ActionTypes.OPEN_TASK_INFO:
      return _objectSpread({}, state, {
        openTaskInfoId: action.value
      });

    case ActionTypes.CLOSE_TASK_INFO:
      return _objectSpread({}, state, {
        openTaskInfoId: -1,
        taskComments: []
      });

    case ActionTypes.CANCEL_TASK_MOVE:
      return _objectSpread({}, state, {
        isATaskMoving: false,
        sourceTaskListId: -1,
        movingTaskId: -1
      });

    case ActionTypes.START_PROJECTS_FETCH:
      return _objectSpread({}, state, {
        isAwaitingFirebase: true
      });

    case ActionTypes.SET_TEXT_INPUT_DIALOG:
      return _objectSpread({}, state, {
        textInputDialog: action.value
      });

    case ActionTypes.LOCAL_PROJECTS:
      return _objectSpread({}, state, {
        localProjects: action.projects,
        projects: [].concat(_toConsumableArray(sortProjects(state.generalConfig.sortProjectsBy, action.projects)), _toConsumableArray(state.remoteProjects)),
        isAwaitingFirebase: false
      });

    case ActionTypes.SET_IS_IN_REGISTER_MODE:
      return _objectSpread({}, state, {
        isInRegisterMode: action.value
      });

    case ActionTypes.RECEIVE_LOCAL_PROJECTS:
      return _objectSpread({}, state, {
        localProjects: action.projects,
        projects: [].concat(_toConsumableArray(sortProjects(state.generalConfig.sortProjectsBy, action.projects)), _toConsumableArray(state.remoteProjects)),
        isAwaitingFirebase: false
      });

    case ActionTypes.RECEIVE_REMOTE_PROJECTS:
      return _objectSpread({}, state, {
        remoteProjects: action.projects,
        projects: [].concat(_toConsumableArray(state.localProjects), _toConsumableArray(sortProjects(state.generalConfig.sortProjectsBy, action.projects)))
      });

    case ActionTypes.SET_UPDATING_USER_IDS:
      {
        return _objectSpread({}, state, {
          updatingUserIds: action.value
        });
      }

    case ActionTypes.RECEIVE_MEMBERS:
      return _objectSpread({}, state, {
        members: action.members,
        memberLookup: buildProjectMembersLookup(action.members),
        selectedProjectLayout: getSelectedProjectLayout(state.selectedProjectId, action.members, state.projectLayoutsMap),
        selectedProjectLayoutType: (0, _pounderUtilities.getProjectLayoutType)(state.selectedProjectId, action.members, (0, _pounderFirebase.getUserUid)())
      });

    case ActionTypes.RECEIVE_INVITES:
      return _objectSpread({}, state, {
        invites: action.invites
      });

    case ActionTypes.START_TASKS_FETCH:
      return _objectSpread({}, state, {
        isAwaitingFirebase: true
      });

    case ActionTypes.RECEIVE_INCOMPLETED_LOCAL_TASKS:
      var newTasks = [].concat(_toConsumableArray(action.value), _toConsumableArray(state.completedLocalTasks), _toConsumableArray(state.incompletedRemoteTasks), _toConsumableArray(state.completedRemoteTasks));
      return _objectSpread({}, state, {
        isAwaitingFirebase: false,
        tasks: newTasks,
        incompletedLocalTasks: action.value,
        projectSelectorIndicators: getProjectSelectorIndicatorsHelper(newTasks),
        openTaskInspectorEntity: updateOpenTaskInspectorEntity(newTasks, state.openTaskInspectorId),
        filteredTasks: filterTasksByProject(newTasks, state.selectedProjectId, state.showOnlySelfTasks)
      });

    case ActionTypes.RECEIVE_COMPLETED_LOCAL_TASKS:
      var newTasks = [].concat(_toConsumableArray(state.incompletedLocalTasks), _toConsumableArray(action.value), _toConsumableArray(state.incompletedRemoteTasks), _toConsumableArray(state.completedRemoteTasks));
      return _objectSpread({}, state, {
        isAwaitingFirebase: false,
        tasks: newTasks,
        completedLocalTasks: action.value,
        openTaskInspectorEntity: updateOpenTaskInspectorEntity(newTasks, state.openTaskInspectorId),
        filteredTasks: filterTasksByProject(newTasks, state.selectedProjectId, state.showOnlySelfTasks)
      });

    case ActionTypes.RECEIVE_INCOMPLETED_REMOTE_TASKS:
      var newTasks = [].concat(_toConsumableArray(state.incompletedLocalTasks), _toConsumableArray(state.completedLocalTasks), _toConsumableArray(action.value), _toConsumableArray(state.completedRemoteTasks));
      return _objectSpread({}, state, {
        isAwaitingFirebase: false,
        tasks: newTasks,
        incompletedRemoteTasks: action.value,
        projectSelectorIndicators: getProjectSelectorIndicatorsHelper(newTasks),
        openTaskInspectorEntity: updateOpenTaskInspectorEntity(newTasks, state.openTaskInspectorId),
        filteredTasks: filterTasksByProject(newTasks, state.selectedProjectId, state.showOnlySelfTasks)
      });

    case ActionTypes.RECEIVE_COMPLETED_REMOTE_TASKS:
      var newTasks = [].concat(_toConsumableArray(state.incompletedLocalTasks), _toConsumableArray(state.completedLocalTasks), _toConsumableArray(state.incompletedRemoteTasks), _toConsumableArray(action.value));
      return _objectSpread({}, state, {
        isAwaitingFirebase: false,
        tasks: newTasks,
        completedRemoteTasks: action.value,
        openTaskInspectorEntity: updateOpenTaskInspectorEntity(newTasks, state.openTaskInspectorId),
        filteredTasks: filterTasksByProject(newTasks, state.selectedProjectId, state.showOnlySelfTasks)
      });

    case ActionTypes.SET_IS_PROJECT_MENU_OPEN:
      return _objectSpread({}, state, {
        isProjectMenuOpen: action.value
      });

    case ActionTypes.LOCK_APP:
      return _objectSpread({}, state, {
        isLockScreenDisplayed: true
      });

    case ActionTypes.SET_LAST_BACKUP_DATE:
      return _objectSpread({}, state, {
        lastBackupDate: action.value
      });

    case ActionTypes.SET_OPEN_TASKLIST_SETTINGS_MENU_ID:
      return _objectSpread({}, state, {
        openTaskListSettingsMenuId: action.id,
        isTaskListJumpMenuOpen: false
      });

    case ActionTypes.UNLOCK_APP:
      return _objectSpread({}, state, {
        isLockScreenDisplayed: false
      });

    case ActionTypes.START_TASKLIST_ADD:
      return _objectSpread({}, state, {
        isAwaitingFirebase: true
      });

    case ActionTypes.START_TASK_ADD:
      return _objectSpread({}, state, {
        isAwaitingFirebase: true
      });

    case ActionTypes.START_TASKLISTS_FETCH:
      return _objectSpread({}, state, {
        isAwaitingFirebase: true
      });

    case ActionTypes.RECEIVE_LOCAL_TASKLISTS:
      var newTaskLists = [].concat(_toConsumableArray(action.taskLists), _toConsumableArray(state.remoteTaskLists));
      var newFilteredTaskLists = filterTaskListsByProject(newTaskLists, state.selectedProjectId);
      return _objectSpread({}, state, {
        isAwaitingFirebase: false,
        taskLists: newTaskLists,
        localTaskLists: action.taskLists,
        openChecklistSettingsEntity: updateOpenChecklistSettingsEntity(newTaskLists, state.openChecklistSettingsId),
        filteredTaskLists: newFilteredTaskLists,
        enableStates: _objectSpread({}, state.enableStates, {
          newTaskFab: state.focusedTaskListId !== -1
        })
      });

    case ActionTypes.RECEIVE_REMOTE_TASKLISTS:
      var newTaskLists = [].concat(_toConsumableArray(state.localTaskLists), _toConsumableArray(action.taskLists));
      var newFilteredTaskLists = filterTaskListsByProject(newTaskLists, state.selectedProjectId);
      return _objectSpread({}, state, {
        isAwatingFirebase: false,
        taskLists: newTaskLists,
        remoteTaskLists: action.taskLists,
        openChecklistSettingsEntity: updateOpenChecklistSettingsEntity(newTaskLists, state.openChecklistSettingsId),
        filteredTaskLists: newFilteredTaskLists,
        enableStates: _objectSpread({}, state.enableStates, {
          newTaskFab: state.focusedTaskListId !== -1
        })
      });

    case ActionTypes.START_PROJECTLAYOUTS_FETCH:
      return _objectSpread({}, state, {
        isAwaitingFirebase: true
      });

    case ActionTypes.RECEIVE_LOCAL_PROJECTLAYOUTS:
      var projectLayoutsMap = buildProjectLayoutsMap(action.value, state.remoteProjectLayouts);
      return _objectSpread({}, state, {
        isAwaitingFirebase: false,
        localProjectLayouts: action.value,
        projectLayoutsMap: projectLayoutsMap,
        selectedProjectLayout: getSelectedProjectLayout(state.selectedProjectId, state.members, projectLayoutsMap)
      });

    case ActionTypes.RECEIVE_REMOTE_PROJECTLAYOUTS:
      var projectLayoutsMap = buildProjectLayoutsMap(state.localProjectLayouts, action.value);
      return _objectSpread({}, state, {
        isAwaitingFirebase: false,
        remoteProjectLayouts: action.value,
        projectLayoutsMap: projectLayoutsMap,
        selectedProjectLayout: getSelectedProjectLayout(state.selectedProjectId, state.members, projectLayoutsMap)
      });

    case ActionTypes.SET_OPEN_PROJECT_SELECTOR_ID:
      return _objectSpread({}, state, {
        openProjectSelectorId: action.value
      });

    case ActionTypes.SELECT_PROJECT:
      var filteredTaskLists = filterTaskListsByProject(state.taskLists, action.projectId); // We Provide -1 as the existing value to maybeForceFocusTaskList because we want it to defocus the List if there are no lists
      // to Focus On. This Occurs when Changing Project selection from one with Lists to one without any lists.

      var focusedTaskListId = action.value === -1 ? -1 : maybeForceFocusTaskList(-1, filteredTaskLists);
      return _objectSpread({}, state, {
        selectedProjectId: action.projectId,
        isSelectedProjectRemote: action.projectId === -1 ? false : isProjectRemote(state, action.projectId),
        selectedTask: {
          taskListWidgetId: -1,
          taskId: -1,
          isInputOpen: false
        },
        selectedProjectLayout: getSelectedProjectLayout(action.projectId, state.members, state.projectLayoutsMap),
        selectedProjectLayoutType: (0, _pounderUtilities.getProjectLayoutType)(action.projectId, state.members, (0, _pounderFirebase.getUserUid)()),
        openTaskOptionsId: -1,
        openTaskListWidgetHeaderId: -1,
        openProjectSelectorId: action.projectId === state.openProjectSelectorId ? state.openProjectSelectorId : -1,
        isATaskMoving: false,
        movingTaskId: -1,
        sourceTaskListId: -1,
        focusedTaskListId: focusedTaskListId,
        openTaskListSettingsMenuId: -1,
        isTaskListJumpMenuOpen: false,
        showOnlySelfTasks: false,
        isAppDrawerOpen: action.projectId === -1 ? true : false,
        enableStates: _objectSpread({}, state.enableStates, {
          newTaskFab: focusedTaskListId !== -1,
          newTaskListFab: action.value !== -1,
          projectMenu: action.value !== -1
        }),
        filteredTasks: filterTasksByProject(state.tasks, action.projectId, state.showOnlySelfTasks),
        filteredTaskLists: filteredTaskLists
      });

    case ActionTypes.SET_PROJECTS_HAVE_PENDING_WRITES:
      return _objectSpread({}, state, {
        projectsHavePendingWrites: action.value
      });

    case ActionTypes.SET_PROJECTLAYOUTS_HAVE_PENDING_WRITES:
      return _objectSpread({}, state, {
        projectLayoutsHavePendingWrites: action.value
      });

    case ActionTypes.SET_TASKLISTS_HAVE_PENDING_WRITES:
      return _objectSpread({}, state, {
        taskListsHavePendingWrites: action.value
      });

    case ActionTypes.SET_TASKS_HAVE_PENDING_WRITES:
      return _objectSpread({}, state, {
        tasksHavePendingWrites: action.value
      });

    case ActionTypes.OPEN_JUMP_MENU:
      return _objectSpread({}, state, {
        isJumpMenuOpen: true
      });

    case ActionTypes.CLOSE_JUMP_MENU:
      return _objectSpread({}, state, {
        isJumpMenuOpen: false
      });

    case ActionTypes.SET_IS_SHUTTING_DOWN_FLAG:
      return _objectSpread({}, state, {
        isShuttingDown: action.value
      });

    case ActionTypes.SET_APP_SETTINGS_MENU_PAGE:
      return _objectSpread({}, state, {
        appSettingsMenuPage: action.value
      });

    case ActionTypes.SET_IS_INDUCTING:
      return _objectSpread({}, state, {
        isInducting: action.value
      });

    case ActionTypes.SET_DATABASE_INFO:
      return _objectSpread({}, state, {
        databaseInfo: action.value
      });

    case ActionTypes.SET_DATABASE_PURGING_FLAG:
      return _objectSpread({}, state, {
        isDatabasePurging: action.value
      });

    case ActionTypes.SET_IS_DATABASE_RESTORING_FLAG:
      return _objectSpread({}, state, {
        isDatabaseRestoring: action.value
      });

    case ActionTypes.RECEIVE_GENERAL_CONFIG:
      {
        if (isFirstTimeBoot(action.value)) {
          // First Time Boot.
          return _objectSpread({}, state, {
            generalConfig: action.value,
            isDexieConfigLoadComplete: true,
            isOnboarding: true,
            isInRegisterMode: true
          });
        }

        if (hasBeenUpdated(action.value) === true && state.isOnboarding === false) {
          // App has just updated.
          return _objectSpread({}, state, {
            generalConfig: action.value,
            isDexieConfigLoadComplete: true,
            isInducting: true
          });
        } else {
          // Normal Config Update.
          return _objectSpread({}, state, {
            generalConfig: action.value,
            isDexieConfigLoadComplete: true,
            projects: maybeReSortProjects(state, action.value),
            // Returns re sorted projects if generalConfig.sortProjectsBy has changed.
            selectedMuiThemeId: action.value.selectedMuiThemeId !== undefined ? action.value.selectedMuiThemeId : state.selectedMuiThemeId
          });
        }
      }

    case ActionTypes.SET_IS_STARTING_UP_FLAG:
      {
        return _objectSpread({}, state, {
          isStartingUp: action.value
        });
      }

    case ActionTypes.SET_IS_DEXIE_CONFIG_LOAD_COMPLETE_FLAG:
      {
        return _objectSpread({}, state, {
          isDexieConfigLoadComplete: action.value
        });
      }

    case ActionTypes.SET_IS_APP_SETTINGS_OPEN:
      {
        return _objectSpread({}, state, {
          isAppSettingsOpen: action.value,
          ignoreFullscreenTrigger: true // Stops the App toggling to Fullscreen imediately as the User selects the option.

        });
      }

    case ActionTypes.SET_IS_ONBOARDING:
      {
        return _objectSpread({}, state, {
          isOnboarding: action.value,
          isAppDrawerOpen: action.value === false
        });
      }

    case ActionTypes.SET_QUICK_ITEM_SELECT_DIALOG:
      {
        return _objectSpread({}, state, {
          quickItemSelectDialog: action.value
        });
      }

    case ActionTypes.RECEIVE_ACCOUNT_CONFIG:
      {
        return _objectSpread({}, state, {
          accountConfig: action.value
        });
      }

    case ActionTypes.SET_IGNORE_FULLSCREEN_TRIGGER_FLAG:
      {
        return _objectSpread({}, state, {
          ignoreFullscreenTrigger: action.value
        });
      }

    case ActionTypes.RECEIVE_CSS_CONFIG:
      {
        return _objectSpread({}, state, {
          cssConfig: action.value
        });
      }

    case ActionTypes.SET_MESSAGE_BOX:
      {
        return _objectSpread({}, state, {
          messageBox: action.value
        });
      }

    case ActionTypes.SET_AUTH_STATUS_MESSAGE:
      {
        return _objectSpread({}, state, {
          authStatusMessage: action.value
        });
      }

    case ActionTypes.SET_IS_LOGGING_IN_FLAG:
      {
        return _objectSpread({}, state, {
          isLoggingIn: action.value
        });
      }

    case ActionTypes.SET_IS_LOGGED_IN_FLAG:
      {
        return _objectSpread({}, state, {
          isLoggedIn: action.value,
          isLoggingIn: false,
          isInRegisterMode: false,
          enableStates: _objectSpread({}, state.enableStates, {
            newProject: action.value
          })
        });
      }

    case ActionTypes.SET_USER_EMAIL:
      {
        return _objectSpread({}, state, {
          userEmail: action.value
        });
      }

    case ActionTypes.SET_OPEN_TASK_OPTIONS_ID:
      {
        return _objectSpread({}, state, {
          openTaskOptionsId: action.value
        });
      }

    case ActionTypes.SET_GENERAL_SNACKBAR:
      {
        return _objectSpread({}, state, {
          generalSnackbar: action.value,
          isASnackbarOpen: action.value.isOpen
        });
      }

    case ActionTypes.DISMISS_SNACKBAR:
      {
        return _objectSpread({}, state, {
          isSnackbarOpen: false,
          snackbarMessage: "",
          isSnackbarSelfDismissing: true
        });
      }

    case ActionTypes.SET_OPEN_METADATA_ID:
      {
        return _objectSpread({}, state, {
          openMetadataId: action.value
        });
      }

    case ActionTypes.CLEAR_DATA:
      {
        return _objectSpread({}, state, {
          projects: [],
          members: [],
          invites: [],
          localProjects: [],
          remoteProjects: [],
          remoteProjectIds: [],
          taskLists: [],
          filteredTaskLists: [],
          localTaskLists: [],
          remoteTaskLists: [],
          tasks: [],
          filteredTasks: [],
          incompletedLocalTasks: [],
          completedLocalTasks: [],
          incompletedRemoteTasks: [],
          completedRemoteTasks: [],
          projectLayoutsMap: {},
          localProjectLayouts: [],
          remoteProjectLayouts: [],
          accountConfig: _pounderFirebase.AccountConfigFallback
        });
      }

    case ActionTypes.SET_UPDATING_INVITE_IDS:
      return _objectSpread({}, state, {
        updatingInviteIds: action.value
      });

    case ActionTypes.OPEN_SHARE_MENU:
      return _objectSpread({}, state, {
        openShareMenuId: action.value
      });

    case ActionTypes.CLOSE_SHARE_MENU:
      return _objectSpread({}, state, {
        openShareMenuId: -1
      });

    case ActionTypes.SET_IS_SHARE_MENU_WAITING:
      {
        return _objectSpread({}, state, {
          isShareMenuWaiting: action.value
        });
      }

    case ActionTypes.SET_SHARE_MENU_MESSAGE:
      {
        return _objectSpread({}, state, {
          shareMenuMessage: action.value
        });
      }

    case ActionTypes.SET_SHARE_MENU_SUB_MESSAGE:
      {
        return _objectSpread({}, state, {
          shareMenuSubMessage: action.value
        });
      }

    case ActionTypes.SET_DISPLAY_NAME:
      {
        return _objectSpread({}, state, {
          displayName: action.value
        });
      }

    case ActionTypes.RECEIVE_LOCAL_MUI_THEMES:
      {
        return _objectSpread({}, state, {
          localMuiThemes: action.value,
          muiThemes: _toConsumableArray(action.value)
        });
      }

    case ActionTypes.SELECT_MUI_THEME:
      {
        return _objectSpread({}, state, {
          selectedMuiThemeId: action.value
        });
      }

    case ActionTypes.RECEIVE_REMOTE_PROJECT_IDS:
      {
        return _objectSpread({}, state, {
          remoteProjectIds: action.value
        });
      }

    case ActionTypes.SET_SHOW_ONLY_SELF_TASKS:
      {
        return _objectSpread({}, state, {
          showOnlySelfTasks: action.value,
          openTaskOptionsId: -1,
          selectedTask: {
            taskListWidgetId: -1,
            taskId: -1,
            isInputOpen: false
          },
          filteredTasks: filterTasksByProject(state.tasks, state.selectedProjectId, action.value)
        });
      }

    case ActionTypes.SET_SHOW_COMPLETED_TASKS:
      {
        return _objectSpread({}, state, {
          showCompletedTasks: action.value
        });
      }

    case ActionTypes.CALCULATE_PROJECT_SELECTOR_INDICATORS:
      {
        return _objectSpread({}, state, {
          projectSelectorIndicators: getProjectSelectorIndicatorsHelper(state.tasks)
        });
      }

    case ActionTypes.SET_IS_UPDATE_SNACKBAR_OPEN:
      {
        return _objectSpread({}, state, {
          isUpdateSnackbarOpen: action.value
        });
      }

    case ActionTypes.START_TASK_COMMENTS_GET:
      return _objectSpread({}, state, {
        taskComments: [],
        isGettingTaskComments: true
      });

    case ActionTypes.RECEIVE_TASK_COMMENTS:
      return _objectSpread({}, state, {
        isGettingTaskComments: false,
        taskComments: action.value
      });

    case ActionTypes.SET_PENDING_TASK_COMMENT_IDS:
      return _objectSpread({}, state, {
        pendingTaskCommentIds: action.value
      });

    case ActionTypes.SET_IS_TASK_COMMENTS_PAGINATING:
      return _objectSpread({}, state, {
        isTaskCommentsPaginating: action.value
      });

    case ActionTypes.SET_IS_ALL_TASK_COMMENTS_FETCHED:
      return _objectSpread({}, state, {
        isAllTaskCommentsFetched: action.value
      });

    case ActionTypes.SET_OPEN_TASK_INSPECTOR_ID:
      return _objectSpread({}, state, {
        openTaskInspectorId: action.value,
        openTaskInspectorEntity: action.value === -1 ? null : extractTask(state.tasks, action.value)
      });

    case ActionTypes.SET_SELECTED_PROJECT_LAYOUT_TYPE:
      return _objectSpread({}, state, {
        selectedProjectLayoutType: action.value,
        selectedProjectLayout: getSelectedProjectLayout(state.selectedProjectId, state.members, state.projectLayoutsMap)
      });

    case ActionTypes.SET_INFORMATION_DIALOG:
      return _objectSpread({}, state, {
        informationDialog: action.value
      });

    case ActionTypes.SET_ITEM_SELECT_DIALOG:
      {
        return _objectSpread({}, state, {
          itemSelectDialog: action.value
        });
      }

    case ActionTypes.SET_CONFIRMATION_DIALOG:
      return _objectSpread({}, state, {
        confirmationDialog: action.value
      });

    case ActionTypes.OPEN_CHECKLIST_SETTINGS:
      return _objectSpread({}, state, {
        openChecklistSettingsId: action.taskListId,
        openChecklistSettingsEntity: action.existingChecklistSettings
      });

    case ActionTypes.CLOSE_CHECKLIST_SETTINGS:
      return _objectSpread({}, state, {
        openChecklistSettingsId: -1,
        openChecklistSettingsEntity: null
      });

    case ActionTypes.STEP_ONBOARDER_FORWARD:
      return _objectSpread({}, state, {
        onboarderStep: state.onboarderStep++
      });

    case ActionTypes.STEP_ONBOARDER_BACKWARDS:
      return _objectSpread({}, state, {
        onboarderStep: state.onboarderStep--
      });

    case ActionTypes.SET_IS_APP_DRAWER_COLLAPSED:
      return _objectSpread({}, state, {
        isAppDrawerCollapsed: action.value
      });

    case ActionTypes.SET_LAST_UNDO_ACTION:
      var lastUndoAction = action.value === undefined ? null : action.value;
      return _objectSpread({}, state, {
        lastUndoAction: lastUndoAction,
        canUndo: lastUndoAction !== null
      });

    case ActionTypes.SET_UNDO_SNACKBAR:
      return _objectSpread({}, state, {
        undoSnackbar: action.value
      });

    default:
      console.log("App Reducer is missing a Case for action:  " + action.type);
      return state;
  }
} // Helper Methods.


function maybeReSortProjects(state, newGeneralConfig) {
  if (state.generalConfig.sortProjectsBy !== newGeneralConfig.sortProjectsBy) {
    // Projects need a resort.
    return [].concat(_toConsumableArray(sortProjects(newGeneralConfig.sortProjectsBy, state.localProjects)), _toConsumableArray(sortProjects(newGeneralConfig.sortProjectsBy, state.remoteProjects)));
  } else {
    // No resort required. Just return as is.
    return state.projects;
  }
}

function sortProjects(sortBy, newProjects) {
  var coercedSortBy = sortBy === undefined ? 'alphabetically' : sortBy;
  var sorterFunction = getProjectSorter(coercedSortBy);
  return newProjects.sort(sorterFunction);
}

function getProjectSorter(sortBy) {
  switch (sortBy) {
    case 'alphabetically':
      return projectAlphabeticalSorter;

    case 'created':
      return projectCreatedSorter;

    case 'updated':
      return projectUpdatedSorter;

    default:
      return projectAlphabeticalSorter;
  }
}

function buildProjectMembersLookup(members) {
  var lookup = {};
  members.forEach(function (member) {
    lookup[member.userId] = member.displayName;
  });
  return lookup;
}

function projectAlphabeticalSorter(a, b) {
  var textA = a.projectName.toUpperCase();
  var textB = b.projectName.toUpperCase();
  return textA < textB ? -1 : textA > textB ? 1 : 0;
}

function projectCreatedSorter(a, b) {
  var coercedA = a.created === undefined ? "" : a.created;
  var coercedB = b.created === undefined ? "" : b.created;
  var dateA = coercedA.length === 0 ? Infinity : new Date(coercedA);
  var dateB = coercedB.length === 0 ? Infinity : new Date(coercedB);
  return dateB - dateA;
}

function projectUpdatedSorter(a, b) {
  var coercedA = a.updated === undefined ? "" : a.updated;
  var coercedB = b.updated === undefined ? "" : b.updated;
  var dateA = coercedA.length === 0 ? -1 : new Date(coercedA);
  var dateB = coercedB.length === 0 ? -1 : new Date(coercedB);
  return dateB - dateA;
}

function isFirstTimeBoot(generalConfig) {
  if (generalConfig !== undefined && generalConfig.isFirstTimeBoot !== undefined) {
    return generalConfig.isFirstTimeBoot;
  } else {
    return false;
  }
}

function processSelectedTask(selectedTask, focusingTaskListId) {
  if (selectedTask.taskListWidgetId !== focusingTaskListId) {
    return {
      taskListWidgetId: -1,
      taskId: -1,
      isInputOpen: false,
      isMetadataOpen: false
    };
  } else {
    return selectedTask;
  }
}

function isProjectRemote(state, projectId) {
  var index = state.remoteProjectIds.findIndex(function (id) {
    return id === projectId;
  });
  return index !== -1;
}

function getProjectSelectorIndicatorsHelper(tasks) {
  var returnList = {};
  tasks.forEach(function (item) {
    var hasUnseenComments = item.unseenTaskCommentMembers !== undefined && item.unseenTaskCommentMembers[(0, _pounderFirebase.getUserUid)()] !== undefined;

    if (item.dueDate !== "" && item.isComplete !== true || hasUnseenComments) {
      // Create an entry in returnList if not already existing.
      if (returnList[item.project] == undefined) {
        returnList[item.project] = {
          later: 0,
          soon: 0,
          today: 0,
          overdue: 0,
          hasUnseenComments: true
        };
      }

      var _ParseDueDate = (0, _pounderUtilities.ParseDueDate)(item.isComplete, item.dueDate),
          type = _ParseDueDate.type;

      switch (type) {
        case "later":
          returnList[item.project].later += 1;
          break;

        case "soon":
          returnList[item.project].soon += 1;
          break;

        case "today":
          returnList[item.project].today += 1;
          break;

        case "overdue":
          returnList[item.project].overdue += 1;
          break;

        default:
          break;
      }

      returnList[item.project].hasUnseenComments = hasUnseenComments;
    }
  });
  return returnList;
}

function getSelectedProjectLayout(projectId, members, projectLayoutsMap) {
  if (projectId === -1) {
    return {};
  }

  if ((0, _pounderUtilities.getProjectLayoutType)(projectId, members, (0, _pounderFirebase.getUserUid)()) === 'global') {
    // Return the Global Layout.
    if (projectLayoutsMap[projectId] !== undefined && projectLayoutsMap[projectId][projectId] !== undefined) {
      return projectLayoutsMap[projectId][projectId];
    }
  } else {
    // Return the Users local Layout.
    return projectLayoutsMap[projectId][(0, _pounderFirebase.getUserUid)()];
  }
}

function buildProjectLayoutsMap(localLayouts, remoteLayouts) {
  var localLayoutsMap = {};
  localLayouts.forEach(function (item) {
    if (localLayoutsMap[item.project] === undefined) {
      localLayoutsMap[item.project] = {};
    }

    ;
    localLayoutsMap[item.project][item.uid] = item;
  });
  var remoteLayoutsMap = {};
  remoteLayouts.forEach(function (item) {
    if (remoteLayoutsMap[item.project] === undefined) {
      remoteLayoutsMap[item.project] = {};
    }

    ;
    remoteLayoutsMap[item.project][item.uid] = item;
  });
  return _objectSpread({}, localLayoutsMap, remoteLayoutsMap);
}

function extractTask(tasks, taskId) {
  return tasks.find(function (item) {
    return item.uid === taskId;
  });
}

function updateOpenTaskInspectorEntity(tasks, taskId) {
  if (taskId === -1) {
    // Task Inspector isn't open. No Update requried.
    return null;
  } else {
    return extractTask(tasks, taskId);
  }
}

function updateOpenChecklistSettingsEntity(taskLists, taskListId) {
  if (taskListId === -1) {
    // Checklist Settings isn't open. No update requried;
    return null;
  } else {
    var taskList = taskLists.find(function (item) {
      return item.uid === taskListId;
    });

    if (taskList) {
      return taskList.settings.checklistSettings;
    }

    return null;
  }
}

function filterTaskListsByProject(taskLists, projectId) {
  if (projectId === -1 || projectId === undefined || taskLists === undefined) {
    return [];
  }

  return taskLists.filter(function (item) {
    return item.project === projectId;
  });
}

function filterTasksByProject(tasks, projectId, showOnlySelfTasks) {
  if (projectId === -1 || projectId === undefined || tasks === undefined) {
    return [];
  }

  var selfTasksExpression = showOnlySelfTasks === true ? function (assignedToId) {
    return assignedToId === (0, _pounderFirebase.getUserUid)();
  } : function () {
    return true;
  };
  return tasks.filter(function (item) {
    return item.project === projectId && selfTasksExpression(item.assignedTo);
  });
}

function maybeForceFocusTaskList(existingValue, filteredTaskLists) {
  if (filteredTaskLists.length >= 1) {
    return filteredTaskLists[0].uid;
  } else {
    return existingValue;
  }
}

function hasBeenUpdated(generalConfig) {
  if (generalConfig.appVersion === undefined || generalConfig.appVersion !== HANDBALL_VERSION) {
    return true;
  } else {
    return false;
  }
}



//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-redux/reducers/index.js
// module id = 643
// module chunks = 0